//angular imports 
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

//angular imports 
import { RoomGroupModel, RoomModel } from '@app/catalog';

@Component({
  selector: 'assign-room-to-room-groups',
  standalone: false,
  templateUrl: './assign-room-to-room-groups.component.html',
  styleUrl: './assign-room-to-room-groups.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignRoomToRoomGroupsComponent {
  onCancelAssignment = output();

  roomGroups = input.required<RoomGroupModel[]>();
  assignedRooms = input.required<RoomModel[]>();
  rooms = input.required<RoomModel[]>();



  public applyAssignment() {

  }
}
